import React from "react";
import BulkModelsUpload from "./BulkModelsUpload";
import BulkSparesUpload from "./BulkSparesUpload";
import BulkUsersUpload from "./BulkUsersUpload";
import BulkPhotosUpload from "./BulkPhotosUpload";
import BulkSpareAction from "./BulkSpareAction";
import { Paper, Typography, Grid, Container, Divider } from "@mui/material";
import BulkSpareStatus from "./BulkSpareStatus";

const BulkUpload = () => {
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 9, ml: 0 }}>
        <Grid container spacing={2} sx={{ px: 0, mb: 0 }} display="flex">
          <Grid item xs={3} md={3}>
            <Typography align="left" sx={{ mr: "auto", color: "#003f93", mb: 1 }} variant="h6">
              Bulk Uploads
            </Typography>
          </Grid>
        </Grid>
        <Paper elevation={3} display="flex" alignItems="center">
          <BulkModelsUpload />
          <Divider sx={{ mt: 0, mb: 1 }} />
          <BulkSparesUpload />
          <Divider sx={{ mt: 0, mb: 1 }} />
          <BulkUsersUpload />
          <Divider sx={{ mt: 0, mb: 1 }} />
          <BulkSpareAction />
          <Divider sx={{ mt: 0, mb: 1 }} />
          <BulkSpareStatus />
          <Divider sx={{ mt: 0, mb: 1 }} />
          <BulkPhotosUpload />
        </Paper>

      </Container>
    </>
  );
};
export default BulkUpload;
